<template>
  <div class="host page">
    <DataTable
      title="Сотрудники"
      :service="service"
      :fields="tableFileds"
      :scheme="scheme"
      :pageSize="5"
      :options="options"
    />
  </div>
</template>

<script>
import DataTable from '@app/components/uikit/DataTable';
import { employeeApi, userApi } from '@app/services';

export default {
  components: { DataTable },
  data: () => ({
    service: employeeApi,
    options: {
      users: {
        getLabel: value => ({
          value: value.email ? value.email : value,
          obj: value,
          label: value.lastName ? value.email ? `${value.email} / ${value.lastName} ${value.firstName} ${value.middleName ? value.middleName : ''}` : `${value.lastName} ${value.firstName} ${value.middleName ? value.middleName : ''}` : value
        }),
        getValues: async search => {
          let items = await userApi.getAll(search);
          items = items.filter(itm => itm.email !== '');
          return { items };
        }
      }
    },
    scheme: {
      controls: {
        email: {
          type: 'autocomplete',
          label: 'Email',
          optionName: 'users',
          placeholder: 'Введите Email...'
        },
        lastName: {
          type: 'text',
          label: 'Фамилия',
          placeholder: 'Введите фамилию...'
        },
        firstName: {
          type: 'text',
          label: 'Имя',
          placeholder: 'Введите имя...'
        },
        middleName: {
          type: 'text',
          label: 'Отчество',
          placeholder: 'Введите отчество...'
        },
        phone: {
          type: 'text',
          label: 'Телефон',
          placeholder: 'Введите телефон...'
        },
        workemail: {
          type: 'text',
          label: 'Рабочий Email',
          placeholder: 'Введите Email...'
        },
        workphone: {
          type: 'text',
          label: 'Рабочий телефон',
          placeholder: 'Введите телефон...',
          maxLength: 16
        }
      }
    },
    tableFileds: [
      {
        name: 'lastName',
        label: 'Фамилия'
      },
      {
        name: 'firstName',
        label: 'Имя'
      },
      {
        name: 'middleName',
        label: 'Отчество'
      }
    ]
  })
};
</script>

